import { TokenType, DateKeys } from './type'

export function getDate(token: TokenType, key: DateKeys) {
  return new Date(token[key] * 1000)
}
